import { Injectable } from '@angular/core';
import { Smartlook as SmartlookCapacitor } from '@awesome-cordova-plugins/smartlook/ngx';
import { IS_NATIVE_APP } from '@pc/common';
import Smartlook from 'smartlook-client';

@Injectable({ providedIn: 'root' })
export class SmartlookService {
  private smartlook!: SmartlookCapacitor;

  public async initialize(key: string) {
    if (IS_NATIVE_APP) {
      this.smartlook = this.getNativeInstance();
      this.smartlook.setProjectKey({
        key: key
      });

      this.smartlook.start();
    } else {
      Smartlook.init(key);
    }
  }

  public record(params: {
    forms?: boolean;
    ips?: boolean;
    numbers?: boolean;
    emails?: boolean;
    api?: boolean;
  }): boolean {
    return Smartlook.record(params);
  }

  public setUserId(key: string, details: Record<string, string | number | boolean> = {}) {
    if (IS_NATIVE_APP) {
      this.smartlook.setUserIdentifier({ identifier: key });
    } else {
      Smartlook.identify(key, details);
    }
  }

  public trackEvent(eventName: string, details: Record<string, string | number | boolean> = {}): void {
    Smartlook.track(eventName, details);
  }

  public logError(error: string | Error): void {
    Smartlook.error(error);
  }

  private getNativeInstance() {
    if (!this.smartlook) {
      this.smartlook = new SmartlookCapacitor();
    }

    return this.smartlook;
  }
}
